var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCustomer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h48v48H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.444 7.616 21.878 21.05l-5.656 5.658-7.78-7.78a8 8 0 0 1 0-11.312h.002zm20.092 16.676L26.828 26 40.97 40.142l-2.828 2.828L24 28.83 9.858 42.97 7.03 40.142l18.678-18.678c-1.176-2.914.04-7.11 3.24-10.314 3.906-3.904 9.288-4.854 12.022-2.12s1.784 8.116-2.12 12.02c-3.204 3.204-7.4 4.42-10.314 3.242z",
    fill: "#DE3530",
    fillRule: "nonzero"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomer);
export default __webpack_public_path__ + "static/media/customer.ab3be5b5ce89039ded6263d6b79ad49e.svg";
export { ForwardRef as ReactComponent };